export class AiAgentSidebarStateService {
    static $inject = ['$timeout'];
    constructor($timeout) {
        this.state = {
            currentSidebar: null,
            data: null,
        };
        this.$timeout = $timeout;
    }
    open(tab, data) {
        this.close();
        this.$timeout(this.applyState.bind(this, tab, data));
    }
    applyState(tab, data) {
        this.state = {
            currentSidebar: tab,
            data: data,
        };
    }
    close() {
        this.state = {
            currentSidebar: null,
            data: null,
        };
    }
    isOpen(tab) {
        return this.state.currentSidebar === tab;
    }
    getData() {
        return this.state.data;
    }
    clearData(keys) {
        if (!this.state.data) {
            return;
        }
        const keysToClear = Array.isArray(keys) ? keys : [keys];
        this.$timeout(() => {
            if (this.state.data) {
                keysToClear.forEach(key => {
                    delete this.state.data[key];
                });
                const hasDataLeft = Object.keys(this.state.data).length > 0;
                if (!hasDataLeft) {
                    this.close();
                }
            }
        });
    }
}
AiAgentSidebarStateService.$inject = ['$timeout'];
